import {useAccountFormStatuses} from '../hooks';

const withAccountFormStatuses = (Component) => {
  return (props) => {
    const statuses = useAccountFormStatuses();
    return <Component statuses={statuses} {...props}/>;
  }
};

export default withAccountFormStatuses;
